import { WORDPRESS_API } from "shared/constants/api";

export const pedagogue = {
  name: "mgr Dorota Kutka",
  role: "Pedagog szkolny i specjalny",
  email: "dorota.kutka@zspwyrzysk.pl"
};

export const pedagoguePoster = {
  src: `${WORDPRESS_API}/wp-content/uploads/2025/09/plakat-tydzien-o-przeciwdzialaniu-przemocy-rowiesniczej@2x.png`,
  alt: "Tydzień o przeciwdziałaniu przemocy rówieśniczej"
};

export const preventionDocuments = [
  {
    id: "tydzien-przeciwdzialania-przemocy",
    title: "Tydzień o przeciwdziałaniu przemocy rówieśniczej",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/materialy-men-cz.-1-tydzien-o-przeciwdzialaniu-przemocy.pdf`
  }
];

export const schoolGuides = [
  {
    id: "profilaktyka-1",
    title: "Profilaktyka nr 1",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/gazetka-Profilaktyka-nr-1.pdf`
  },
  {
    id: "profilaktyka-2",
    title: "Profilaktyka nr 2",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/gazetka-Profilaktyka-nr-2-69ef3674c63a4.pdf`
  },
  {
    id: "profilaktyka-3",
    title: "Profilaktyka nr 3",
    href: "https://dokumenty.men.gov.pl/gazetka-Profilaktyka-nr-3-6a16c6948a9b1.pdf"
  },
  {
    id: "profilaktyka-4",
    title: "Profilaktyka nr 4",
    href: "https://dokumenty.men.gov.pl/gazetka-Profilaktyka-nr-4-6a2c0e384b654.pdf"
  },
  {
    id: "profilaktyka-5",
    title: "Profilaktyka nr 5",
    href: "https://dokumenty.men.gov.pl/gazetka-Profilaktyka-nr-5-6a6336a569049.pdf"
  },
  {
    id: "profilaktyka-6",
    title: "Profilaktyka nr 6",
    href: "https://dokumenty.men.gov.pl/gazetka-Profilaktyka-nr-6-6a90353db212d.pdf"
  },
  {
    id: "profilaktyka-7",
    title: "Profilaktyka nr 7",
    href: "https://dokumenty.men.gov.pl/gazetka-Profilaktyka-nr-7-6ab64bfe79514.pdf"
  },
  {
    id: "dzialanie-w-sytuacji-zagrozenia",
    title: "Działanie w sytuacji zagrożenia",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Dzialanie-w-sytuacji-zagrozenia-poradnik-2026.pdf`
  }
];

export const selfStudyDocuments = [
  {
    id: "materialy-do-samoksztalcenia",
    title: "Materiały do samokształcenia",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/zalacznik-nr-2-materialy-do-samoksztalcenia-w-programie-dzialaj-rozmawiaj-liderzy-wsparcia-rowiesniczego-fiep-2.pdf`
  },
  {
    id: "techniki-radzenia-sobie-z-emocjami",
    title: "Techniki radzenia sobie z trudnymi emocjami",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Zalacznik-nr-13-Techniki-radzenia-sobie-z-trudnymi-emocjami-dla-nastolatkow-12-18-lat-68c44037df932.pdf`
  },
  {
    id: "dlaczego-czujesz",
    title: "Dlaczego czujesz to, co czujesz?",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/zalacznik-nr-17-dlaczego-czujesz-to-co-czujesz-ebook-dla-nastolatkow-14-18-lat.pdf`
  }
];

export const helpDocuments = [
  {
    id: "pomoc-uczen",
    title: "Ścieżka pomocy – Przemoc rówieśnicza w szkole – Dla ucznia",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/sciezka-pomocy-dla-ucznia-przemoc-rowiesnicza.pdf`
  },
  {
    id: "pomoc-rodzic",
    title: "Ścieżka pomocy – Przemoc rówieśnicza w szkole – Dla rodzica",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/sciezka-pomocy-dla-rodzica-przemoc-rowiesnicza.pdf`
  },
  {
    id: "pomoc-szkola",
    title: "Ścieżka pomocy w sytuacji wystąpienia przemocy rówieśniczej – Dla szkoły",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/sciezka-pomocy-dla-szkoly-przemoc-rowiesnicza.pdf`
  }
];

export const pedagogueTasks = [
  "Udzielanie porad rodzicom w zakresie możliwości uzyskania porady specjalistycznej dla dziecka i rodziny.",
  "Wspieranie rodziców w wychowywaniu dziecka – konsultacje i porady.",
  "Wywiady z rodzicami lub prawnymi opiekunami w celu rozpoznania środowiska ucznia.",
  "Rozpoznawanie indywidualnych potrzeb i możliwości psychofizycznych dziecka.",
  "Obserwacja pedagogiczna.",
  "Rozwiązywanie problemów i konfliktów w klasie – mediacje.",
  "Zajęcia wychowawcze z klasami.",
  "Bieżąca wychowawcza praca z uczniami.",
  "Rozmowy wspierające i motywujące z uczniami.",
  "Podejmowanie działań w sytuacjach wskazujących na występowanie zjawiska przemocy rówieśniczej.",
  "Kierowanie dzieci na badania psychologiczne, specjalistyczne (na prośbę rodziców i nauczycieli).",
  "Udzielanie pomocy psychologiczno-pedagogicznej.",
  "Rozmowy profilaktyczne z uczniem w obecności rodziców, wychowawcy, kuratora, dyrektora szkoły.",
  "Interwencje kryzysowe.",
  "Przygotowanie wniosków do Sądu Rodzinnego.",
  "Współpraca z instytucjami typu: OPS, PCPR, policja.",
  "Konsultacje z wychowawcą na temat bieżącej pracy ucznia."
];